(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ormi-bloom-tres-videos"] && !Shopify.designMode) return;
  try {
    
  const initializeOrmiVideoGalleries = () => {
    document.querySelectorAll('.ormi-video-gallery').forEach((gallery) => {
      if (gallery.dataset.initialized === 'true') return;
      gallery.dataset.initialized = 'true';

      const videos = gallery.querySelectorAll('video');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      videos.forEach((video) => {
        video.muted = true;
        video.playsInline = true;
      });

      if (gallery.dataset.autoplay !== 'true' || reduceMotion) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => undefined);
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.55 });

      videos.forEach((video) => observer.observe(video));
    });
  };

  initializeOrmiVideoGalleries();
  document.addEventListener('shopify:section:load', initializeOrmiVideoGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ormi-producto-principal"] && !Shopify.designMode) return;
  try {
    
  const initializeOrmiMainProducts = () => {
    document.querySelectorAll('[data-ormi-main]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const slides = Array.from(section.querySelectorAll('[data-slide]'));
      const thumbs = Array.from(section.querySelectorAll('[data-gallery-thumb]'));
      const previous = section.querySelector('[data-gallery-previous]');
      const next = section.querySelector('[data-gallery-next]');
      const counter = section.querySelector('[data-gallery-counter]');
      const price = section.querySelector('[data-main-price]');
      const compare = section.querySelector('[data-main-compare]');
      const stage = section.querySelector('.ormi-main__stage');
      let activeIndex = 0;
      let touchStartX = 0;

      const showSlide = (requestedIndex) => {
        if (!slides.length) return;
        activeIndex = (requestedIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbs.forEach((thumb, index) => {
          const active = index === activeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        });
        if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      };

      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
      if (previous) previous.addEventListener('click', () => showSlide(activeIndex - 1));
      if (next) next.addEventListener('click', () => showSlide(activeIndex + 1));

      if (stage) {
        stage.addEventListener('touchstart', (event) => {
          touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', (event) => {
          const distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 45) return;
          showSlide(distance > 0 ? activeIndex - 1 : activeIndex + 1);
        }, { passive: true });
      }

      section.querySelectorAll('.ormi-main__pack-input').forEach((input) => {
        input.addEventListener('change', () => {
          if (price) price.textContent = input.dataset.price;
          if (compare) {
            compare.textContent = input.dataset.compare;
            compare.hidden = !input.dataset.compare;
          }
        });
      });

      if (slides.length < 2) {
        if (previous) previous.hidden = true;
        if (next) next.hidden = true;
      }
      showSlide(0);
    });
  };

  initializeOrmiMainProducts();
  document.addEventListener('shopify:section:load', initializeOrmiMainProducts);

  } catch(e) { console.error(e); }
})();
})();
